<section
  class="card mb-4"
  [formGroup]="formGroup"
  [ngClass]="
    isDetailsInvalidAndValidated() ? 'border-danger border-2' : borderClass
  "
>
  <div class="card-header" [ngClass]="backgroundClass">
    <div class="form-check">
      <input
        type="checkbox"
        class="form-check-input"
        [id]="controlName.DetailsCheckbox"
        [formControlName]="controlName.DetailsCheckbox"
      />

      <label
        class="form-check-label checkbox"
        [attr.for]="controlName.DetailsCheckbox"
      >
        {{ title | translate }}
      </label>
    </div>
  </div>

  <ng-container *ngIf="isDetailsVisible()">
    <div class="card-body">
      <ng-container *ngIf="!multiple; else multipleTemplate">
        <ng-container
          *ngTemplateOutlet="
            investorDetails;
            context: { formGroup: getDetailsFormGroup(), idPrefix: idPrefix }
          "
        ></ng-container>
      </ng-container>
      <ng-template #multipleTemplate>
        <div class="row">
          <ng-container
            *ngFor="
              let control of getDetailsFormArray()?.controls;
              let i = index
            "
          >
            <div class="col-12 mt-3 mb-3">
              <div class="card">
                <div
                  class="card-header d-flex justify-content-between align-items-center"
                >
                  <span class="my-1">
                    {{ singleElementTitle | translate }}
                    <ng-container *ngIf="getDetailsFormArray()?.length > 1">
                      {{ i + 1 }}
                    </ng-container>
                  </span>
                  <button
                    *ngIf="getDetailsFormArray()?.length > 1"
                    (click)="removeDetailsFormGroup(i)"
                    type="button"
                    class="btn btn-danger btn-sm"
                  >
                    <i class="fa fa-times me-2"></i>
                    <strong>{{ removeButtonText | translate }}</strong>
                  </button>
                </div>
                <div class="card-body">
                  <ng-container
                    *ngTemplateOutlet="
                      investorDetails;
                      context: {
                        formGroup: getDetailsFormGroup(i),
                        idPrefix: idPrefix + i + '-',
                      }
                    "
                  ></ng-container>
                </div>
                <div *ngIf="control.invalid && submitted" class="card-footer">
                  <div class="alert alert-danger my-2">
                    {{ validationMessage | translate }}
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
        <button
          (click)="addDetailsFormGroup()"
          type="button"
          aria-label="plus"
          class="btn"
          [ngClass]="buttonClass"
        >
          <i class="fa fa-plus" aria-hidden="true"></i>
          {{ addButtonText | translate }}
        </button>
      </ng-template>

      @if (infoVisible) {
        <div class="alert alert-info mt-3" role="alert">
          <ng-container
            *ngIf="
              documentSectionService.isProxyAttachmentAvailableToPayOnline(
                portalId
              ) | async;
              else standardInfo
            "
          >
            {{ onlinePaymentInfoText | translate }}
          </ng-container>
          <ng-template #standardInfo>{{ infoText | translate }}</ng-template>
        </div>
      }
    </div>
  </ng-container>
</section>

<ng-template #investorDetails let-formGroup="formGroup" let-idPrefix="idPrefix">
  <app-investor-details
    [legalPersonEnabled]="false"
    [investorDetailsFromGroup]="formGroup"
    [automaticCopyingDataFromPz]="false"
    [isPeselVisible]="isPeselVisible"
    [isIdVisible]="false"
    [isEPUAPAddressVisible]="true"
    [isPhoneNumberRequired]="false"
    [isEmailRequired]="false"
    [proxyTypeVisible]="proxyTypeFormControlVisible"
    [wasFormValidated]="submitted"
    [idPrefix]="idPrefix"
  ></app-investor-details>
</ng-template>
